import React, {Component} from 'react';
import {Input, Button, Segment, Checkbox, Divider, Message} from 'semantic-ui-react';

/*

Requires the following props:

laptopFilterCategories: list of categories for filtering
errorMessages: source of error status (array)
priceRangeLow: source of aforementioned textbox
priceRangeHigh: source of aforementioned textbox
handlePriceRangeTextBoxChange: func to call when either either textbox text changes
handleKeyPress: func to call (must handle pressing enter)
handleApply: func to call when user clicks apply
handleReset: func to call when user clicks reset
handleCheckboxChange: func to call when use clicks a checkbox

*/
export class NavbarFilter extends Component {
  laptopFilterCategories;
  errorMessages;
  priceRangeLow;
  priceRangeHigh;
  handleApply;
  handleReset;
  handleCheckboxChange;

  render() {
    let filterCategories = this.props.laptopFilterCategories;
    return (
      <Segment>

        <h3>Filters</h3>

        <Button onClick={this.props.handleReset}>
          <Button.Content visible>
            Reset
          </Button.Content>
        </Button>

        <h4>Price Range</h4>
        <Message
          error
          hidden={!this.props.errorMessages.length}
          header={'There were some errors with your submission'}
          list={this.props.errorMessages}
        />
        <Input
          name='lowDisplayed'
          size='mini'
          value={this.props.priceRangeLow}
          onChange={this.props.handlePriceRangeTextBoxChange}
        />
        <Divider fitted hidden clearing />
        to
        <Divider fitted hidden clearing />
        <Input
          name='highDisplayed'
          size='mini'
          value={this.props.priceRangeHigh}
          onChange={this.props.handlePriceRangeTextBoxChange}
        />
        <Divider fitted hidden />
        <Divider fitted hidden />
        <Button size='mini' onClick={this.props.handleApply}>
          <Button.Content visible>
            Apply
          </Button.Content>
        </Button>

        <h4>Manufacturer</h4>
        {filterCategories.manufacturers.map(manufacturer => (
          <div key={manufacturer.brand}>
            <Checkbox
              label={manufacturer.brand}
              name="manufacturer"
              value={manufacturer.brand}
              checked={manufacturer.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Screen Size</h4>
        {filterCategories.screenSizes.map(size => (
          <div key={size.screenSize}>
            <Checkbox
              label={size.screenSize}
              name="screenSize"
              value={size.screenSize}
              checked={size.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Panel Type</h4>
        {filterCategories.panelTypes.map(type => (
          <div key={type.panelType}>
            <Checkbox
              label={type.panelType}
              name="panelType"
              value={type.panelType}
              checked={type.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Screen Resolution</h4>
        {filterCategories.resolutions.map(res => (
          <div key={res.resolution.uniqueKey}>
            <Checkbox
              label={res.resolution.width + ' x ' + res.resolution.height}
              name="resolution"
              value={res.resolution.uniqueKey}
              checked={res.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Touchscreen Function</h4>
        <Checkbox
          label='Touchscreen'
          name="touchscreen"
          value={filterCategories.touchscreen.checked.toString()}
          checked={filterCategories.touchscreen.checked}
          onChange={this.props.handleCheckboxChange}
        />

        <h4>Weight</h4>
        {filterCategories.weights.map(w => (
          <div key={w.type}>
            <Checkbox
              label={(() => {
                switch (w.type) {
                  case 'Feather':
                    return '< 2.5 lbs (Feather)';
                  case 'Light':
                    return '< 4.0 lbs (Light)';
                  case 'Medium':
                    return '< 5.0 lbs (Medium)';
                  case 'Heavy':
                    return '< 7.0 lbs (Heavy)';
                  case 'Brick':
                    return '> 7.0 lbs (Brick)';
                  default :
                    return 'Unrecognized';
                }
              })()}
              name="weight"
              value={w.type}
              checked={w.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>CPU Manufacturer</h4>
        {filterCategories.cpuManufacturers.map(m => (
          <div key={m.manufacturer}>
            <Checkbox
              label={m.manufacturer}
              name="cpuManufacturer"
              value={m.manufacturer}
              checked={m.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>CPU Cores</h4>
        {filterCategories.cpuCores.map(c => (
          <div key={c.cores}>
            <Checkbox
              label={c.cores}
              name="cpuCores"
              value={c.cores}
              checked={c.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>RAM</h4>
        {filterCategories.ramSizes.map(s => (
          <div key={s.ramSize}>
            <Checkbox
              label={(() => {
                switch (s.ramSize) {
                  case 1:
                    return '1 GB';
                  case 2:
                    return '2 GB';
                  case 4:
                    return '4 GB';
                  case 8:
                    return '8 GB';
                  case 16:
                    return '16 GB';
                  case 32:
                    return '32+ GB';
                  default :
                    return 'Unrecognized';
                }
              })()}
              name="ramSize"
              value={s.ramSize}
              checked={s.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>HD Types</h4>
        {filterCategories.hdTypes.map(t => (
          <div key={t.type}>
            <Checkbox
              label={t.type}
              name="hdType"
              value={t.type}
              checked={t.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Storage Capacity</h4>
        {filterCategories.hdSizes.map(s => (
          <div key={s.hdSize}>
            <Checkbox
              label={(() => {
                switch (s.hdSize) {
                  case 128:
                    return '128 GB';
                  case 256:
                    return '256 GB';
                  case 512:
                    return '512 GB';
                  case 1000:
                    return '1 TB';
                  case 2000:
                    return '2+ TB';
                  default :
                    return 'Unrecognized';
                }
              })()}
              name="hdSize"
              value={s.hdSize}
              checked={s.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Graphics Type</h4>
        {filterCategories.gpuTypes.map(t => (
          <div key={t.type}>
            <Checkbox
              label={t.type}
              name="gpuType"
              value={t.type}
              checked={t.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Graphics Manufacturer</h4>
        {filterCategories.gpuManufacturers.map(m => (
          <div key={m.manufacturer}>
            <Checkbox
              label={m.manufacturer}
              name="gpuManufacturer"
              value={m.manufacturer}
              checked={m.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Dedicated Graphics RAM</h4>
        {filterCategories.gpuRamSizes.map(s => (
          <div key={s.gpuRamSize}>
            <Checkbox
              label={s.gpuRamSize ? s.gpuRamSize + ' GB' : 'None'}
              name="gpuRamSize"
              value={s.gpuRamSize}
              checked={s.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Operating System</h4>
        {filterCategories.operatingSystems.map(os => (
          <div key={os.type}>
            <Checkbox
              label={os.type}
              name="operatingSystem"
              value={os.type}
              checked={os.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Ports</h4>
        {filterCategories.portTypes.map(p => (
          <div key={p.portType}>
            <Checkbox
              label={p.portType}
              name="portType"
              value={p.portType}
              checked={p.checked}
              onChange={this.props.handleCheckboxChange}
            />
          </div>
        ))}

        <h4>Optical Drive Built-In</h4>
        <Checkbox
          label='Optical Drive'
          name="opticalDrive"
          value={filterCategories.opticalDrive.checked.toString()}
          checked={filterCategories.opticalDrive.checked}
          onChange={this.props.handleCheckboxChange}
        />

        <h4>Webcam Built-In</h4>
        <Checkbox
          label='Webcam'
          name="webcam"
          value={filterCategories.webcam.checked.toString()}
          checked={filterCategories.webcam.checked}
          onChange={this.props.handleCheckboxChange}
        />

        <h4>Bluetooth Built-In</h4>
        <Checkbox
          label='Bluetooth'
          name="bluetooth"
          value={filterCategories.bluetooth.checked.toString()}
          checked={filterCategories.bluetooth.checked}
          onChange={this.props.handleCheckboxChange}
        />
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/NavbarFilter/NavbarFilter.js